import { all, fork } from 'redux-saga/effects';

import statusSagas from '@app/store/bulkRequest/requestTasks/status/sagas';
import tasksSagas from '@app/store/bulkRequest/requestTasks/tasks/sagas';

export default function* sagas() {
  yield all([fork(statusSagas), fork(tasksSagas)]);
}
